import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    TeamsList,
    CurrentTeam,
    setDefaultData,
    sanitize,
    kebabToTitle
  } from '../utils'
import { Client, Account, Databases, Functions } from "appwrite";
import { getWidgetData, updateWidgetData } from '../appwrite/methods'
import InfoTooltip from './InfoTooltip'

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';


// const client = new Client()
//     .setEndpoint(process.env.REACT_APP_ENDPOINT)
//     .setProject(process.env.REACT_APP_PROJECT_ID);

// const account = new Account(client);
// const db = new Databases(client);
// const functions = new Functions(client);


/**
 * @Counter
 *
 * @param {int} number Required. Default number for the counter.
 * @param {int} min Optional. Minimum number for the counter. If unspecified, defaults to none.
 * @param {int} max Optional. Maximum number for the counter. If unspecified, defaults to none.
 * @param {String} header Optional. Header text for the number counter. If unspecified, no header will be shown.
 * @param {String} label Optional. Label text for the number counter. If unspecified, no label will be shown.
 * @param {String} widgetName Optional. The name of the widget to save data to. If unspecified, data will only be saved to cache.
 * @param {String} docKey Optional. The key to store selected items by in the user's database. If unspecified, will only be saved to cache (reset on page reload).
 * 
 * @returns {JSX.Element} Rendered Counter component.
*/
/**
 * @TODO
 * - 
 */
export default function Counter({ number, min, max, header, label, widgetName, docKey, tooltip, tooltipIcon }) {
    const [userSession] = useAtom(UserSession);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);

    const [num, setNum] = useState(number);


    // Get existing data, or fallback to default
    useEffect(() => {
        if (teamsList.length > 0) {
            const widgetData = getWidgetData(
                sanitize(teamsList[currentTeam]),
                userSession.$id,
                kebabToTitle(widgetName),
                docKey
            ).then(data => {
                if (data) setNum(data);
            })

            if (widgetData === undefined) setNum(number);
        }
    }, [teamsList]);

    function update(value) {
        const intValue = parseInt(value, 10);
        setNum(intValue);
        updateWidgetData(
            sanitize(teamsList[currentTeam]),
            userSession.$id,
            kebabToTitle(widgetName),
            { [docKey]: intValue },
            {
                [docKey]: {
                    type: 'integer',
                    min: min,
                    max: max
                }
            }
        )
    }

    return (<>
        <Stack direction="row" spacing={1}>
            {header && <Typography variant="h6" gutterBottom>{header}</Typography>}
            {tooltip && <Stack><InfoTooltip text={tooltip} icon={tooltipIcon} /></Stack>}
        </Stack>
        <TextField
            label={label}
            variant="outlined"
            size="small"
            type="number"
            slotProps={{
                inputLabel: {
                    shrink: true,
                },
            }}
            value={num}
            onChange={(e) => update(e.target.value)}
            sx={{ mr: 1 }}
        />
    </>)
}